export const secondsToMilliseconds = (seconds: number) => seconds * 1000;

export const secondsToMinutes = (seconds: number) => Math.floor(seconds / 60);

export const getCurrentTimezoneOffset = (): string => {
  return 'UTC+00:00';
};
